import { shiftLabel, STAFF_SHIFT_ORDER, DEFAULT_STAFF_SHIFT } from './staffShifts';

export const CORPORATE_HOURS = 'Mon–Fri · 8:30 AM – 4:30 PM';
export const WAREHOUSE_SHIFT_ORDER = STAFF_SHIFT_ORDER;
export const DEFAULT_WAREHOUSE_SHIFT = DEFAULT_STAFF_SHIFT;
export const warehouseShiftLabel = shiftLabel;
export const isCorporateEmployee = employee => employee.employee_kind === 'admin'
  || ['admin', 'company_manager'].includes(employee.role) || employee.assigned_shift === 'admin_office';
export const employeeScheduleLabel = employee => employee.shift_schedule?.label
  || (employee.assigned_shift === 'admin_office' ? CORPORATE_HOURS : shiftLabel(employee.assigned_shift));